/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 3.19.1
 * source: google/firestore/v1beta1/write.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./common";
import * as dependency_2 from "./document";
import * as dependency_3 from "./../../protobuf/timestamp";
import * as pb_1 from "google-protobuf";
export class Write extends pb_1.Message {
    #one_of_decls: number[][] = [[1, 2, 6]];
    constructor(data?: any[] | ({
        update_mask?: dependency_1.DocumentMask;
        update_transforms?: DocumentTransformFieldTransform[];
        current_document?: dependency_1.Precondition;
    } & (({
        update?: dependency_2.Document;
        delete?: never;
        transform?: never;
    } | {
        update?: never;
        delete?: string;
        transform?: never;
    } | {
        update?: never;
        delete?: never;
        transform?: DocumentTransform;
    })))) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [7], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("update" in data && data.update != undefined) {
                this.update = data.update;
            }
            if ("delete" in data && data.delete != undefined) {
                this.delete = data.delete;
            }
            if ("transform" in data && data.transform != undefined) {
                this.transform = data.transform;
            }
            if ("update_mask" in data && data.update_mask != undefined) {
                this.update_mask = data.update_mask;
            }
            if ("update_transforms" in data && data.update_transforms != undefined) {
                this.update_transforms = data.update_transforms;
            }
            if ("current_document" in data && data.current_document != undefined) {
                this.current_document = data.current_document;
            }
        }
    }
    get update() {
        return pb_1.Message.getWrapperField(this, dependency_2.Document, 1) as dependency_2.Document;
    }
    set update(value: dependency_2.Document) {
        pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value);
    }
    get has_update() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get delete() {
        return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
    }
    set delete(value: string) {
        pb_1.Message.setOneofField(this, 2, this.#one_of_decls[0], value);
    }
    get has_delete() {
        return pb_1.Message.getField(this, 2) != null;
    }
    get transform() {
        return pb_1.Message.getWrapperField(this, DocumentTransform, 6) as DocumentTransform;
    }
    set transform(value: DocumentTransform) {
        pb_1.Message.setOneofWrapperField(this, 6, this.#one_of_decls[0], value);
    }
    get has_transform() {
        return pb_1.Message.getField(this, 6) != null;
    }
    get update_mask() {
        return pb_1.Message.getWrapperField(this, dependency_1.DocumentMask, 3) as dependency_1.DocumentMask;
    }
    set update_mask(value: dependency_1.DocumentMask) {
        pb_1.Message.setWrapperField(this, 3, value);
    }
    get has_update_mask() {
        return pb_1.Message.getField(this, 3) != null;
    }
    get update_transforms() {
        return pb_1.Message.getRepeatedWrapperField(this, DocumentTransformFieldTransform, 7) as DocumentTransformFieldTransform[];
    }
    set update_transforms(value: DocumentTransformFieldTransform[]) {
        pb_1.Message.setRepeatedWrapperField(this, 7, value);
    }
    get current_document() {
        return pb_1.Message.getWrapperField(this, dependency_1.Precondition, 4) as dependency_1.Precondition;
    }
    set current_document(value: dependency_1.Precondition) {
        pb_1.Message.setWrapperField(this, 4, value);
    }
    get has_current_document() {
        return pb_1.Message.getField(this, 4) != null;
    }
    get operation() {
        const cases: {
            [index: number]: "none" | "update" | "delete" | "transform";
        } = {
            0: "none",
            1: "update",
            2: "delete",
            6: "transform"
        };
        return cases[pb_1.Message.computeOneofCase(this, [1, 2, 6])];
    }
    static fromObject(data: {
        update?: ReturnType<typeof dependency_2.Document.prototype.toObject>;
        delete?: string;
        transform?: ReturnType<typeof DocumentTransform.prototype.toObject>;
        update_mask?: ReturnType<typeof dependency_1.DocumentMask.prototype.toObject>;
        update_transforms?: ReturnType<typeof DocumentTransformFieldTransform.prototype.toObject>[];
        current_document?: ReturnType<typeof dependency_1.Precondition.prototype.toObject>;
    }): Write {
        const message = new Write({});
        if (data.update != null) {
            message.update = dependency_2.Document.fromObject(data.update);
        }
        if (data.delete != null) {
            message.delete = data.delete;
        }
        if (data.transform != null) {
            message.transform = DocumentTransform.fromObject(data.transform);
        }
        if (data.update_mask != null) {
            message.update_mask = dependency_1.DocumentMask.fromObject(data.update_mask);
        }
        if (data.update_transforms != null) {
            message.update_transforms = data.update_transforms.map(item => DocumentTransformFieldTransform.fromObject(item));
        }
        if (data.current_document != null) {
            message.current_document = dependency_1.Precondition.fromObject(data.current_document);
        }
        return message;
    }
    toObject() {
        const data: {
            update?: ReturnType<typeof dependency_2.Document.prototype.toObject>;
            delete?: string;
            transform?: ReturnType<typeof DocumentTransform.prototype.toObject>;
            update_mask?: ReturnType<typeof dependency_1.DocumentMask.prototype.toObject>;
            update_transforms?: ReturnType<typeof DocumentTransformFieldTransform.prototype.toObject>[];
            current_document?: ReturnType<typeof dependency_1.Precondition.prototype.toObject>;
        } = {};
        if (this.update != null) {
            data.update = this.update.toObject();
        }
        if (this.delete != null) {
            data.delete = this.delete;
        }
        if (this.transform != null) {
            data.transform = this.transform.toObject();
        }
        if (this.update_mask != null) {
            data.update_mask = this.update_mask.toObject();
        }
        if (this.update_transforms != null) {
            data.update_transforms = this.update_transforms.map((item: DocumentTransformFieldTransform) => item.toObject());
        }
        if (this.current_document != null) {
            data.current_document = this.current_document.toObject();
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_update)
            writer.writeMessage(1, this.update, () => this.update.serialize(writer));
        if (this.has_delete)
            writer.writeString(2, this.delete);
        if (this.has_transform)
            writer.writeMessage(6, this.transform, () => this.transform.serialize(writer));
        if (this.has_update_mask)
            writer.writeMessage(3, this.update_mask, () => this.update_mask.serialize(writer));
        if (this.update_transforms.length)
            writer.writeRepeatedMessage(7, this.update_transforms, (item: DocumentTransformFieldTransform) => item.serialize(writer));
        if (this.has_current_document)
            writer.writeMessage(4, this.current_document, () => this.current_document.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Write {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Write();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.update, () => message.update = dependency_2.Document.deserialize(reader));
                    break;
                case 2:
                    message.delete = reader.readString();
                    break;
                case 6:
                    reader.readMessage(message.transform, () => message.transform = DocumentTransform.deserialize(reader));
                    break;
                case 3:
                    reader.readMessage(message.update_mask, () => message.update_mask = dependency_1.DocumentMask.deserialize(reader));
                    break;
                case 7:
                    reader.readMessage(message.update_transforms, () => pb_1.Message.addToRepeatedWrapperField(message, 7, DocumentTransformFieldTransform.deserialize(reader), DocumentTransformFieldTransform));
                    break;
                case 4:
                    reader.readMessage(message.current_document, () => message.current_document = dependency_1.Precondition.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): Write {
        return Write.deserialize(bytes);
    }
}
export class DocumentTransform extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        document?: string;
        field_transforms?: DocumentTransformFieldTransform[];
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("document" in data && data.document != undefined) {
                this.document = data.document;
            }
            if ("field_transforms" in data && data.field_transforms != undefined) {
                this.field_transforms = data.field_transforms;
            }
        }
    }
    get document() {
        return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
    }
    set document(value: string) {
        pb_1.Message.setField(this, 1, value);
    }
    get field_transforms() {
        return pb_1.Message.getRepeatedWrapperField(this, DocumentTransformFieldTransform, 2) as DocumentTransformFieldTransform[];
    }
    set field_transforms(value: DocumentTransformFieldTransform[]) {
        pb_1.Message.setRepeatedWrapperField(this, 2, value);
    }
    static fromObject(data: {
        document?: string;
        field_transforms?: ReturnType<typeof DocumentTransformFieldTransform.prototype.toObject>[];
    }): DocumentTransform {
        const message = new DocumentTransform({});
        if (data.document != null) {
            message.document = data.document;
        }
        if (data.field_transforms != null) {
            message.field_transforms = data.field_transforms.map(item => DocumentTransformFieldTransform.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data: {
            document?: string;
            field_transforms?: ReturnType<typeof DocumentTransformFieldTransform.prototype.toObject>[];
        } = {};
        if (this.document != null) {
            data.document = this.document;
        }
        if (this.field_transforms != null) {
            data.field_transforms = this.field_transforms.map((item: DocumentTransformFieldTransform) => item.toObject());
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.document.length)
            writer.writeString(1, this.document);
        if (this.field_transforms.length)
            writer.writeRepeatedMessage(2, this.field_transforms, (item: DocumentTransformFieldTransform) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DocumentTransform {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DocumentTransform();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.document = reader.readString();
                    break;
                case 2:
                    reader.readMessage(message.field_transforms, () => pb_1.Message.addToRepeatedWrapperField(message, 2, DocumentTransformFieldTransform.deserialize(reader), DocumentTransformFieldTransform));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): DocumentTransform {
        return DocumentTransform.deserialize(bytes);
    }
}
export class DocumentTransformFieldTransform extends pb_1.Message {
    #one_of_decls: number[][] = [[2, 3, 4, 5, 6, 7]];
    constructor(data?: any[] | ({
        field_path?: string;
    } & (({
        set_to_server_value?: DocumentTransformFieldTransformServerValue;
        increment?: never;
        maximum?: never;
        minimum?: never;
        append_missing_elements?: never;
        remove_all_from_array?: never;
    } | {
        set_to_server_value?: never;
        increment?: dependency_2.Value;
        maximum?: never;
        minimum?: never;
        append_missing_elements?: never;
        remove_all_from_array?: never;
    } | {
        set_to_server_value?: never;
        increment?: never;
        maximum?: dependency_2.Value;
        minimum?: never;
        append_missing_elements?: never;
        remove_all_from_array?: never;
    } | {
        set_to_server_value?: never;
        increment?: never;
        maximum?: never;
        minimum?: dependency_2.Value;
        append_missing_elements?: never;
        remove_all_from_array?: never;
    } | {
        set_to_server_value?: never;
        increment?: never;
        maximum?: never;
        minimum?: never;
        append_missing_elements?: dependency_2.ArrayValue;
        remove_all_from_array?: never;
    } | {
        set_to_server_value?: never;
        increment?: never;
        maximum?: never;
        minimum?: never;
        append_missing_elements?: never;
        remove_all_from_array?: dependency_2.ArrayValue;
    })))) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("field_path" in data && data.field_path != undefined) {
                this.field_path = data.field_path;
            }
            if ("set_to_server_value" in data && data.set_to_server_value != undefined) {
                this.set_to_server_value = data.set_to_server_value;
            }
            if ("increment" in data && data.increment != undefined) {
                this.increment = data.increment;
            }
            if ("maximum" in data && data.maximum != undefined) {
                this.maximum = data.maximum;
            }
            if ("minimum" in data && data.minimum != undefined) {
                this.minimum = data.minimum;
            }
            if ("append_missing_elements" in data && data.append_missing_elements != undefined) {
                this.append_missing_elements = data.append_missing_elements;
            }
            if ("remove_all_from_array" in data && data.remove_all_from_array != undefined) {
                this.remove_all_from_array = data.remove_all_from_array;
            }
        }
    }
    get field_path() {
        return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
    }
    set field_path(value: string) {
        pb_1.Message.setField(this, 1, value);
    }
    get set_to_server_value() {
        return pb_1.Message.getFieldWithDefault(this, 2, DocumentTransformFieldTransformServerValue.SERVER_VALUE_UNSPECIFIED) as DocumentTransformFieldTransformServerValue;
    }
    set set_to_server_value(value: DocumentTransformFieldTransformServerValue) {
        pb_1.Message.setOneofField(this, 2, this.#one_of_decls[0], value);
    }
    get has_set_to_server_value() {
        return pb_1.Message.getField(this, 2) != null;
    }
    get increment() {
        return pb_1.Message.getWrapperField(this, dependency_2.Value, 3) as dependency_2.Value;
    }
    set increment(value: dependency_2.Value) {
        pb_1.Message.setOneofWrapperField(this, 3, this.#one_of_decls[0], value);
    }
    get has_increment() {
        return pb_1.Message.getField(this, 3) != null;
    }
    get maximum() {
        return pb_1.Message.getWrapperField(this, dependency_2.Value, 4) as dependency_2.Value;
    }
    set maximum(value: dependency_2.Value) {
        pb_1.Message.setOneofWrapperField(this, 4, this.#one_of_decls[0], value);
    }
    get has_maximum() {
        return pb_1.Message.getField(this, 4) != null;
    }
    get minimum() {
        return pb_1.Message.getWrapperField(this, dependency_2.Value, 5) as dependency_2.Value;
    }
    set minimum(value: dependency_2.Value) {
        pb_1.Message.setOneofWrapperField(this, 5, this.#one_of_decls[0], value);
    }
    get has_minimum() {
        return pb_1.Message.getField(this, 5) != null;
    }
    get append_missing_elements() {
        return pb_1.Message.getWrapperField(this, dependency_2.ArrayValue, 6) as dependency_2.ArrayValue;
    }
    set append_missing_elements(value: dependency_2.ArrayValue) {
        pb_1.Message.setOneofWrapperField(this, 6, this.#one_of_decls[0], value);
    }
    get has_append_missing_elements() {
        return pb_1.Message.getField(this, 6) != null;
    }
    get remove_all_from_array() {
        return pb_1.Message.getWrapperField(this, dependency_2.ArrayValue, 7) as dependency_2.ArrayValue;
    }
    set remove_all_from_array(value: dependency_2.ArrayValue) {
        pb_1.Message.setOneofWrapperField(this, 7, this.#one_of_decls[0], value);
    }
    get has_remove_all_from_array() {
        return pb_1.Message.getField(this, 7) != null;
    }
    get transform_type() {
        const cases: {
            [index: number]: "none" | "set_to_server_value" | "increment" | "maximum" | "minimum" | "append_missing_elements" | "remove_all_from_array";
        } = {
            0: "none",
            2: "set_to_server_value",
            3: "increment",
            4: "maximum",
            5: "minimum",
            6: "append_missing_elements",
            7: "remove_all_from_array"
        };
        return cases[pb_1.Message.computeOneofCase(this, [2, 3, 4, 5, 6, 7])];
    }
    static fromObject(data: {
        field_path?: string;
        set_to_server_value?: DocumentTransformFieldTransformServerValue;
        increment?: ReturnType<typeof dependency_2.Value.prototype.toObject>;
        maximum?: ReturnType<typeof dependency_2.Value.prototype.toObject>;
        minimum?: ReturnType<typeof dependency_2.Value.prototype.toObject>;
        append_missing_elements?: ReturnType<typeof dependency_2.ArrayValue.prototype.toObject>;
        remove_all_from_array?: ReturnType<typeof dependency_2.ArrayValue.prototype.toObject>;
    }): DocumentTransformFieldTransform {
        const message = new DocumentTransformFieldTransform({});
        if (data.field_path != null) {
            message.field_path = data.field_path;
        }
        if (data.set_to_server_value != null) {
            message.set_to_server_value = data.set_to_server_value;
        }
        if (data.increment != null) {
            message.increment = dependency_2.Value.fromObject(data.increment);
        }
        if (data.maximum != null) {
            message.maximum = dependency_2.Value.fromObject(data.maximum);
        }
        if (data.minimum != null) {
            message.minimum = dependency_2.Value.fromObject(data.minimum);
        }
        if (data.append_missing_elements != null) {
            message.append_missing_elements = dependency_2.ArrayValue.fromObject(data.append_missing_elements);
        }
        if (data.remove_all_from_array != null) {
            message.remove_all_from_array = dependency_2.ArrayValue.fromObject(data.remove_all_from_array);
        }
        return message;
    }
    toObject() {
        const data: {
            field_path?: string;
            set_to_server_value?: DocumentTransformFieldTransformServerValue;
            increment?: ReturnType<typeof dependency_2.Value.prototype.toObject>;
            maximum?: ReturnType<typeof dependency_2.Value.prototype.toObject>;
            minimum?: ReturnType<typeof dependency_2.Value.prototype.toObject>;
            append_missing_elements?: ReturnType<typeof dependency_2.ArrayValue.prototype.toObject>;
            remove_all_from_array?: ReturnType<typeof dependency_2.ArrayValue.prototype.toObject>;
        } = {};
        if (this.field_path != null) {
            data.field_path = this.field_path;
        }
        if (this.set_to_server_value != null) {
            data.set_to_server_value = this.set_to_server_value;
        }
        if (this.increment != null) {
            data.increment = this.increment.toObject();
        }
        if (this.maximum != null) {
            data.maximum = this.maximum.toObject();
        }
        if (this.minimum != null) {
            data.minimum = this.minimum.toObject();
        }
        if (this.append_missing_elements != null) {
            data.append_missing_elements = this.append_missing_elements.toObject();
        }
        if (this.remove_all_from_array != null) {
            data.remove_all_from_array = this.remove_all_from_array.toObject();
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.field_path.length)
            writer.writeString(1, this.field_path);
        if (this.has_set_to_server_value)
            writer.writeEnum(2, this.set_to_server_value);
        if (this.has_increment)
            writer.writeMessage(3, this.increment, () => this.increment.serialize(writer));
        if (this.has_maximum)
            writer.writeMessage(4, this.maximum, () => this.maximum.serialize(writer));
        if (this.has_minimum)
            writer.writeMessage(5, this.minimum, () => this.minimum.serialize(writer));
        if (this.has_append_missing_elements)
            writer.writeMessage(6, this.append_missing_elements, () => this.append_missing_elements.serialize(writer));
        if (this.has_remove_all_from_array)
            writer.writeMessage(7, this.remove_all_from_array, () => this.remove_all_from_array.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DocumentTransformFieldTransform {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DocumentTransformFieldTransform();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.field_path = reader.readString();
                    break;
                case 2:
                    message.set_to_server_value = reader.readEnum();
                    break;
                case 3:
                    reader.readMessage(message.increment, () => message.increment = dependency_2.Value.deserialize(reader));
                    break;
                case 4:
                    reader.readMessage(message.maximum, () => message.maximum = dependency_2.Value.deserialize(reader));
                    break;
                case 5:
                    reader.readMessage(message.minimum, () => message.minimum = dependency_2.Value.deserialize(reader));
                    break;
                case 6:
                    reader.readMessage(message.append_missing_elements, () => message.append_missing_elements = dependency_2.ArrayValue.deserialize(reader));
                    break;
                case 7:
                    reader.readMessage(message.remove_all_from_array, () => message.remove_all_from_array = dependency_2.ArrayValue.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): DocumentTransformFieldTransform {
        return DocumentTransformFieldTransform.deserialize(bytes);
    }
}
export enum DocumentTransformFieldTransformServerValue {
    SERVER_VALUE_UNSPECIFIED = 0,
    REQUEST_TIME = 1
}
export class WriteResult extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        update_time?: dependency_3.Timestamp;
        transform_results?: dependency_2.Value[];
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("update_time" in data && data.update_time != undefined) {
                this.update_time = data.update_time;
            }
            if ("transform_results" in data && data.transform_results != undefined) {
                this.transform_results = data.transform_results;
            }
        }
    }
    get update_time() {
        return pb_1.Message.getWrapperField(this, dependency_3.Timestamp, 1) as dependency_3.Timestamp;
    }
    set update_time(value: dependency_3.Timestamp) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get has_update_time() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get transform_results() {
        return pb_1.Message.getRepeatedWrapperField(this, dependency_2.Value, 2) as dependency_2.Value[];
    }
    set transform_results(value: dependency_2.Value[]) {
        pb_1.Message.setRepeatedWrapperField(this, 2, value);
    }
    static fromObject(data: {
        update_time?: ReturnType<typeof dependency_3.Timestamp.prototype.toObject>;
        transform_results?: ReturnType<typeof dependency_2.Value.prototype.toObject>[];
    }): WriteResult {
        const message = new WriteResult({});
        if (data.update_time != null) {
            message.update_time = dependency_3.Timestamp.fromObject(data.update_time);
        }
        if (data.transform_results != null) {
            message.transform_results = data.transform_results.map(item => dependency_2.Value.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data: {
            update_time?: ReturnType<typeof dependency_3.Timestamp.prototype.toObject>;
            transform_results?: ReturnType<typeof dependency_2.Value.prototype.toObject>[];
        } = {};
        if (this.update_time != null) {
            data.update_time = this.update_time.toObject();
        }
        if (this.transform_results != null) {
            data.transform_results = this.transform_results.map((item: dependency_2.Value) => item.toObject());
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_update_time)
            writer.writeMessage(1, this.update_time, () => this.update_time.serialize(writer));
        if (this.transform_results.length)
            writer.writeRepeatedMessage(2, this.transform_results, (item: dependency_2.Value) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WriteResult {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WriteResult();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.update_time, () => message.update_time = dependency_3.Timestamp.deserialize(reader));
                    break;
                case 2:
                    reader.readMessage(message.transform_results, () => pb_1.Message.addToRepeatedWrapperField(message, 2, dependency_2.Value.deserialize(reader), dependency_2.Value));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): WriteResult {
        return WriteResult.deserialize(bytes);
    }
}
export class DocumentChange extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        document?: dependency_2.Document;
        target_ids?: number[];
        removed_target_ids?: number[];
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5, 6], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("document" in data && data.document != undefined) {
                this.document = data.document;
            }
            if ("target_ids" in data && data.target_ids != undefined) {
                this.target_ids = data.target_ids;
            }
            if ("removed_target_ids" in data && data.removed_target_ids != undefined) {
                this.removed_target_ids = data.removed_target_ids;
            }
        }
    }
    get document() {
        return pb_1.Message.getWrapperField(this, dependency_2.Document, 1) as dependency_2.Document;
    }
    set document(value: dependency_2.Document) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get has_document() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get target_ids() {
        return pb_1.Message.getFieldWithDefault(this, 5, []) as number[];
    }
    set target_ids(value: number[]) {
        pb_1.Message.setField(this, 5, value);
    }
    get removed_target_ids() {
        return pb_1.Message.getFieldWithDefault(this, 6, []) as number[];
    }
    set removed_target_ids(value: number[]) {
        pb_1.Message.setField(this, 6, value);
    }
    static fromObject(data: {
        document?: ReturnType<typeof dependency_2.Document.prototype.toObject>;
        target_ids?: number[];
        removed_target_ids?: number[];
    }): DocumentChange {
        const message = new DocumentChange({});
        if (data.document != null) {
            message.document = dependency_2.Document.fromObject(data.document);
        }
        if (data.target_ids != null) {
            message.target_ids = data.target_ids;
        }
        if (data.removed_target_ids != null) {
            message.removed_target_ids = data.removed_target_ids;
        }
        return message;
    }
    toObject() {
        const data: {
            document?: ReturnType<typeof dependency_2.Document.prototype.toObject>;
            target_ids?: number[];
            removed_target_ids?: number[];
        } = {};
        if (this.document != null) {
            data.document = this.document.toObject();
        }
        if (this.target_ids != null) {
            data.target_ids = this.target_ids;
        }
        if (this.removed_target_ids != null) {
            data.removed_target_ids = this.removed_target_ids;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_document)
            writer.writeMessage(1, this.document, () => this.document.serialize(writer));
        if (this.target_ids.length)
            writer.writePackedInt32(5, this.target_ids);
        if (this.removed_target_ids.length)
            writer.writePackedInt32(6, this.removed_target_ids);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DocumentChange {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DocumentChange();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.document, () => message.document = dependency_2.Document.deserialize(reader));
                    break;
                case 5:
                    message.target_ids = reader.readPackedInt32();
                    break;
                case 6:
                    message.removed_target_ids = reader.readPackedInt32();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): DocumentChange {
        return DocumentChange.deserialize(bytes);
    }
}
export class DocumentDelete extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        document?: string;
        removed_target_ids?: number[];
        read_time?: dependency_3.Timestamp;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [6], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("document" in data && data.document != undefined) {
                this.document = data.document;
            }
            if ("removed_target_ids" in data && data.removed_target_ids != undefined) {
                this.removed_target_ids = data.removed_target_ids;
            }
            if ("read_time" in data && data.read_time != undefined) {
                this.read_time = data.read_time;
            }
        }
    }
    get document() {
        return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
    }
    set document(value: string) {
        pb_1.Message.setField(this, 1, value);
    }
    get removed_target_ids() {
        return pb_1.Message.getFieldWithDefault(this, 6, []) as number[];
    }
    set removed_target_ids(value: number[]) {
        pb_1.Message.setField(this, 6, value);
    }
    get read_time() {
        return pb_1.Message.getWrapperField(this, dependency_3.Timestamp, 4) as dependency_3.Timestamp;
    }
    set read_time(value: dependency_3.Timestamp) {
        pb_1.Message.setWrapperField(this, 4, value);
    }
    get has_read_time() {
        return pb_1.Message.getField(this, 4) != null;
    }
    static fromObject(data: {
        document?: string;
        removed_target_ids?: number[];
        read_time?: ReturnType<typeof dependency_3.Timestamp.prototype.toObject>;
    }): DocumentDelete {
        const message = new DocumentDelete({});
        if (data.document != null) {
            message.document = data.document;
        }
        if (data.removed_target_ids != null) {
            message.removed_target_ids = data.removed_target_ids;
        }
        if (data.read_time != null) {
            message.read_time = dependency_3.Timestamp.fromObject(data.read_time);
        }
        return message;
    }
    toObject() {
        const data: {
            document?: string;
            removed_target_ids?: number[];
            read_time?: ReturnType<typeof dependency_3.Timestamp.prototype.toObject>;
        } = {};
        if (this.document != null) {
            data.document = this.document;
        }
        if (this.removed_target_ids != null) {
            data.removed_target_ids = this.removed_target_ids;
        }
        if (this.read_time != null) {
            data.read_time = this.read_time.toObject();
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.document.length)
            writer.writeString(1, this.document);
        if (this.removed_target_ids.length)
            writer.writePackedInt32(6, this.removed_target_ids);
        if (this.has_read_time)
            writer.writeMessage(4, this.read_time, () => this.read_time.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DocumentDelete {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DocumentDelete();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.document = reader.readString();
                    break;
                case 6:
                    message.removed_target_ids = reader.readPackedInt32();
                    break;
                case 4:
                    reader.readMessage(message.read_time, () => message.read_time = dependency_3.Timestamp.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): DocumentDelete {
        return DocumentDelete.deserialize(bytes);
    }
}
export class DocumentRemove extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        document?: string;
        removed_target_ids?: number[];
        read_time?: dependency_3.Timestamp;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("document" in data && data.document != undefined) {
                this.document = data.document;
            }
            if ("removed_target_ids" in data && data.removed_target_ids != undefined) {
                this.removed_target_ids = data.removed_target_ids;
            }
            if ("read_time" in data && data.read_time != undefined) {
                this.read_time = data.read_time;
            }
        }
    }
    get document() {
        return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
    }
    set document(value: string) {
        pb_1.Message.setField(this, 1, value);
    }
    get removed_target_ids() {
        return pb_1.Message.getFieldWithDefault(this, 2, []) as number[];
    }
    set removed_target_ids(value: number[]) {
        pb_1.Message.setField(this, 2, value);
    }
    get read_time() {
        return pb_1.Message.getWrapperField(this, dependency_3.Timestamp, 4) as dependency_3.Timestamp;
    }
    set read_time(value: dependency_3.Timestamp) {
        pb_1.Message.setWrapperField(this, 4, value);
    }
    get has_read_time() {
        return pb_1.Message.getField(this, 4) != null;
    }
    static fromObject(data: {
        document?: string;
        removed_target_ids?: number[];
        read_time?: ReturnType<typeof dependency_3.Timestamp.prototype.toObject>;
    }): DocumentRemove {
        const message = new DocumentRemove({});
        if (data.document != null) {
            message.document = data.document;
        }
        if (data.removed_target_ids != null) {
            message.removed_target_ids = data.removed_target_ids;
        }
        if (data.read_time != null) {
            message.read_time = dependency_3.Timestamp.fromObject(data.read_time);
        }
        return message;
    }
    toObject() {
        const data: {
            document?: string;
            removed_target_ids?: number[];
            read_time?: ReturnType<typeof dependency_3.Timestamp.prototype.toObject>;
        } = {};
        if (this.document != null) {
            data.document = this.document;
        }
        if (this.removed_target_ids != null) {
            data.removed_target_ids = this.removed_target_ids;
        }
        if (this.read_time != null) {
            data.read_time = this.read_time.toObject();
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.document.length)
            writer.writeString(1, this.document);
        if (this.removed_target_ids.length)
            writer.writePackedInt32(2, this.removed_target_ids);
        if (this.has_read_time)
            writer.writeMessage(4, this.read_time, () => this.read_time.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DocumentRemove {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DocumentRemove();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.document = reader.readString();
                    break;
                case 2:
                    message.removed_target_ids = reader.readPackedInt32();
                    break;
                case 4:
                    reader.readMessage(message.read_time, () => message.read_time = dependency_3.Timestamp.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): DocumentRemove {
        return DocumentRemove.deserialize(bytes);
    }
}
export class ExistenceFilter extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        target_id?: number;
        count?: number;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("target_id" in data && data.target_id != undefined) {
                this.target_id = data.target_id;
            }
            if ("count" in data && data.count != undefined) {
                this.count = data.count;
            }
        }
    }
    get target_id() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
    }
    set target_id(value: number) {
        pb_1.Message.setField(this, 1, value);
    }
    get count() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
    }
    set count(value: number) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data: {
        target_id?: number;
        count?: number;
    }): ExistenceFilter {
        const message = new ExistenceFilter({});
        if (data.target_id != null) {
            message.target_id = data.target_id;
        }
        if (data.count != null) {
            message.count = data.count;
        }
        return message;
    }
    toObject() {
        const data: {
            target_id?: number;
            count?: number;
        } = {};
        if (this.target_id != null) {
            data.target_id = this.target_id;
        }
        if (this.count != null) {
            data.count = this.count;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.target_id != 0)
            writer.writeInt32(1, this.target_id);
        if (this.count != 0)
            writer.writeInt32(2, this.count);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ExistenceFilter {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ExistenceFilter();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.target_id = reader.readInt32();
                    break;
                case 2:
                    message.count = reader.readInt32();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ExistenceFilter {
        return ExistenceFilter.deserialize(bytes);
    }
}
